import emailCustomConfig from 'EmailEditorUI/redux/inpageSync/customConfig';
const emailCustomSyncConfig = emailCustomConfig();
class SyncConfigManager {
  constructor(configBuilder) {
    this.configBuilder = configBuilder;
  }
  clear() {
    this.syncConfig = undefined;
  }
  getConfig() {
    if (this.syncConfig === undefined) {
      this.syncConfig = this.configBuilder();
    }
    return this.syncConfig;
  }
}
export { SyncConfigManager as BaseSyncConfigManager };
const emailCustomSyncConfigManagerInstance = new SyncConfigManager(emailCustomConfig);
export default emailCustomSyncConfigManagerInstance;